import { Form } from 'react-bootstrap'
import { styled } from 'styled-components'

export const Checkbox = styled(Form.Check)`
  display: flex;
  gap: 1rem;

  padding-left: 0;

  > .form-check-input {
    width: 1rem;
    height: 1rem;
    aspect-ratio: 1;

    appearance: none;
    -webkit-appearance: none;
    float: unset;

    margin-top: 0.5rem;
    margin-left: 0;

    outline: 1px solid var(--bs-secondary);
    border: 2px solid var(--bs-white);
    border-radius: 50%;

    @media screen and (min-width: 768px) {
      width: 1.25rem;
      height: 1.25rem;

      outline-width: 2px;
      border-width: 4px;

      margin-top: 0.25rem;
    }

    &:checked {
      background-color: var(--bs-secondary);
      background-image: none;
    }
  }

  > .form-check-label a {
    color: var(--bs-white);
  }
`
